
import React from 'react';

import FSIndex from "@dndComponents/FSIndex";

export default function RaceIndex() {
  return (
    <FSIndex
      data_type="race"
    />
  );
}
